"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rep_common_1 = require("@sa/rep-common");
class ReactReportContextType {
    constructor(options) {
        this.reportContext = options.reportContext;
        this._componentsPipeline = new rep_common_1.PipelineSync();
        options.componentsMiddlewares.forEach((x) => this._componentsPipeline.use(x));
    }
    getComponent(id) {
        const reportId = this.reportContext.definition.id;
        // get component context from core
        const componentContext = this.reportContext.getComponentContext(id);
        const processingState = {
            identification: {
                componentId: id,
                reportId: reportId,
            },
            componentContext: componentContext,
        };
        const pipelineResult = this._componentsPipeline.execute(processingState);
        if (pipelineResult.component === undefined) {
            throw new Error(`Component ${id} for report ${reportId} does not registered`);
        }
        const component = pipelineResult.component;
        return component;
    }
}
exports.ReactReportContextType = ReactReportContextType;
//# sourceMappingURL=ReactReportContextType.js.map